import { Col, List, Row } from "antd";
import {
  InputField,
  PhoneInput,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../components";
import styles from "./AddSubVendor.module.css";
import { LocIcon } from "../../../components/icons/Icons";
import Dropdown from "../../../components/dropdowns/Dropdown";
import { useNavigate } from "react-router-dom";
import { IoIosMail } from "react-icons/io";
import { BsTelephoneFill } from "react-icons/bs";
import { memo, useRef, useState } from "react";
import addDoc from "../../../assets/staticImages/addDoc.png";
import addImage from "../../../assets/staticImages/addImage.png";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { RiDeleteBinLine } from "react-icons/ri";
import { IoCloseSharp } from "react-icons/io5";
import { BiPlus, BiSolidMinusCircle } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import AutoCompleteInput from "../../../components/auntoCompleteInput/AutoCompleteInput";
import { VendorMiddleware } from "../../../Store/Middlewares/VendorMiddleware";

const inputs = {
  label: "Add Social Links",
  type: "text",
  placeholder: "https://www.instagram.com/Trish",
  multiple: true,
  list: [{ placeholder: "https://www.instagram.com/Trish", value: "" }],
};

const servicesArr = [
  "Photography",
  "Portrait Sessions",
  "Bridal Photography",
  "Product Photography",
  "Videography",
];

const RenderDoc = memo(({ docs, i }) => {
  return (
    <DocViewer
      documents={[docs]}
      pluginRenderers={DocViewerRenderers}
      className={styles.pdfView}
      config={{
        header: { disableHeader: true },
        pdfVerticalScrollByDefault: false,
      }}
      language="en"
    />
  );
});

const RenderDocView = memo(({ docs, setDocs, i, doc }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  function handleDropdown(e) {
    e.stopPropagation();
    setDropdownOpen((prev) => !prev);
  }
  const deleteDoc = (id) => {
    console.log("iddddddddddddddddddd", id);
    const arr = docs.filter((data) => {
      console.log(id != data.id);
      if (id != data.id) {
        return data;
      }
    });
    setDocs(arr);
    setDropdownOpen(false);
  };

  return (
    <Col className={styles.pdfCol} key={docs[i].id.toString()}>
      <Row style={{ justifyContent: "flex-end" }}>
        <TextComponent textClass={styles.dropdownBtn} onClick={handleDropdown}>
          ...
        </TextComponent>
      </Row>
      {dropdownOpen && (
        <Row className={styles.dropdown}>
          <Col>
            <Row
              className={styles.dropdownItem}
              onClick={() => deleteDoc(docs[i].id)}
            >
              <RiDeleteBinLine fontSize="1.1rem" />
              <TextComponent textClass={styles.dropdownText}>
                Delete
              </TextComponent>
            </Row>
          </Col>
        </Row>
      )}
      <RenderDoc docs={doc} i={i} />
    </Col>
  );
});

const AddSubVendor = () => {
  const dispatch = useDispatch();
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [email, setEmail] = useState("");
  const [category, setCategory] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [currentLocation, setCurrentLocation] = useState();
  const [socialLinks, setSocialLinks] = useState(inputs);
  const [serviceText, setServiceText] = useState("");
  const [about, setAbout] = useState("");
  const [docs, setDocs] = useState([]);
  const [linkList, setLinkList] = useState([]);
  const [staffImages, setStaffImages] = useState([]);

  const SubVendorCategories = useSelector(
    (state) => state?.GeneralReducer?.GeneralTypes?.servicecategory
  );
  const docRef = useRef();
  const imageRef = useRef();
  const urlRegex =
    /(^https?|^http):\/\/www\.?[a-zA-Z0-9.-]+(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?$/i;
  console.log("docs", docs);
  const handleClick = () => {
    docRef.current.value = "";
    docRef.current.click();
  };
  const navigate = useNavigate();

  const handleAdd = () => {
    let link = socialLinks?.list[socialLinks?.list?.length - 1]?.value;
    if (urlRegex.test(link)) {
      let arr = link?.split(".");
      let domain = arr[arr.length - 2];
      linkList?.push({ link: link, platform: domain });
      setSocialLinks((prev) => ({
        ...prev,
        list: [...prev.list, { placeholder: "Social Link", value: "" }],
      }));
    } else {
      dispatch(
        showAlert({
          title: "Link",
          message: "Please enter valid social link",
          type: "Error",
          status: 400,
        })
      );
    }
    // const newLink = {
    //   placeholder: "Social Link",
    //   value: "",
    // };
    // setSocialLinks((prev) => ({ ...prev, list: [...prev.list, newLink] }));
  };


  const handleChange = (e, i) => {
    setSocialLinks((prev) => ({
      ...prev,
      list: prev.list.map((listItem, index) => {
        if (index === i) {
          return { ...listItem, value: e.target.value };
        } else {
          return listItem;
        }
      }),
    }));
  };

  const handleRemove = (i) => {
    setSocialLinks((prev) => ({
      ...prev,
      list: prev.list.filter((listItem, index) => index !== i),
    }));
    linkList?.splice(i, 1);
  };

  // const addServices = () => {
  //   setServices((prev) => [...prev, serviceText]);
  //   setServiceText("");
  // };

  // const removeService = (i) => {
  //   setServices((prev) => prev.filter((text, index) => i !== index));
  // };
  const onPressCreate = () => {
    if (
      !category ||
      !firstName ||
      !lastName ||
      !email ||
      !contactNo ||
      // !currentLocation ||
      !about ||
      !serviceText
    ) {
      dispatch(
        showAlert({
          title: "Add sub vendor",
          message: "All fields are mandatory.",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) == false
    ) {
      dispatch(
        showAlert({
          title: "Add sub vendor",
          message:
            "Please enter a valid email address in the correct format (e.g., example@example.com)",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (linkList?.length == 0) {
      dispatch(
        showAlert({
          title: "Add sub vendor",
          message: "Add social link.",
          type: "Error",
          status: 400,
        })
      );
      return;
    }
    // else if (docs?.length == 0) {
    //   dispatch(
    //     showAlert({
    //       title: "Add sub vendor",
    //       message: "Add document.",
    //       type: "Error",
    //       status: 400,
    //     })
    //   );
    //   return;
    // }
    else {
      let subVendorData = {
        category_id: category?.id,
        firstName,
        lastName,
        email,
        contact: contactNo,
        address: currentLocation?.address
          ? currentLocation?.address
          : "New york",
        lat: currentLocation?.lat ? currentLocation?.lat : 40.73061,
        lng: currentLocation?.lng ? currentLocation?.lng : -73.935242,
        linkList,
        about,
        service: serviceText,
        selectedFile: docs,
        images: staffImages,
      };
      dispatch(VendorMiddleware.createSubVendor(subVendorData))
        .then(() => {
          navigate(-1);
          navigate("/profile/subVendors");
        })
        .catch((err) => console.log(err));
    }
  };

  const handleImageClick = () => {
    imageRef.current.click();
  };

  const deleteImage = (index) => {
    let imgObjCpy = [...staffImages];
    imgObjCpy.splice(index, 1);
    setStaffImages(imgObjCpy);
  };

  const renderImages = (item, index) => {
    return (
      <div className={styles.listItem}>
        <img src={URL.createObjectURL(item)} />

        <BiSolidMinusCircle
          className={styles.icon}
          onClick={() => deleteImage(index)}
        />
      </div>
    );
  };
  return (
    <>
      <Row>
        <TextComponent textClass={styles.heading}>
          Personal Information
        </TextComponent>
      </Row>
      <Row className={styles.row} justify={"space-between"} gutter={16}>
        <Col xs={24} md={12}>
          <InputField
            label="First Name"
            placeholder="Trish"
            value={firstName}
            onChange={(e) => setfirstName(e.target.value)}
          />
        </Col>
        <Col xs={24} md={12}>
          <InputField
            label="Last Name"
            placeholder="James"
            value={lastName}
            onChange={(e) => setlastName(e.target.value)}
          />
        </Col>
        <Col xs={24} md={12}>
          <InputField
            label="Email"
            type="email"
            rightIcon={<IoIosMail size={18} color="var(--primary-color)" />}
            placeholder="email@bestdayever.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Col>
        <Col xs={24} md={12}>
          <Dropdown
            stylesClass={styles.dropdownClass}
            placeholder="Select category"
            label="Category"
            object={SubVendorCategories}
            onChange={(e) => setCategory(e)}
          // options={[
          //   { value: "Florist", option: "Florist" },
          //   { value: "Catering", option: "Catering" },
          //   { value: "Transportation", option: "Transportation" },
          //   { value: "Photos & Videography", option: "Photos & Videography" },
          // ]}
          />
        </Col>
        <Col xs={24} md={12}>
          {/* <InputField
            label="Contact Number"
            type="number"
            rightIcon={
              <BsTelephoneFill size={18} color="var(--primary-color)" />
            }
            placeholder="+1 (234) 456-4567"
          /> */}
          <PhoneInput
            label="Contact Number"
            placeholder="+1 (234) 456-4567"
            value={contactNo}
            onChange={(e) => setContactNo(e)}
          />
        </Col>
        <Col xs={24} md={12}>
          <AutoCompleteInput
            label={"Address"}
            placeholder={"Enter Address"}
            address={currentLocation?.address}
            onSelectPlace={(place) => {
              let currentLocation = {
                lat: place?.geometry?.location?.lat(),
                lng: place?.geometry?.location?.lng(),
                address: place?.formatted_address,
              };
              setCurrentLocation(currentLocation);
            }}
          />
        </Col>
        <Col xs={24} md={12}>
          {socialLinks.list.map((inp, i) => (
            <Row
              style={{
                justifyContent: "space-between",
                alignItems: "flex-end",
              }}
            >
              <Col xs={18} sm={20} md={19} lg={21} xl={21}>
                <InputField
                  label={i === 0 && socialLinks.label}
                  placeholder={inp.placeholder}
                  disabled={i !== socialLinks.list.length - 1}
                  value={inp.value}
                  onChange={(e) => handleChange(e, i)}
                />
              </Col>
              <Col
                xs={5}
                sm={4}
                md={4}
                lg={3}
                xl={2}
                className={styles.addBtnCol}
              >
                <div
                  className={
                    i === socialLinks.list.length - 1
                      ? styles.addBtn
                      : styles.closeBtn
                  }
                >
                  {i === socialLinks.list.length - 1 ? (
                    <BiPlus onClick={() => handleAdd()} />
                  ) : (
                    <IoCloseSharp onClick={() => handleRemove(i)} />
                  )}
                </div>
              </Col>
            </Row>
          ))}
        </Col>
        <Col xs={24} md={12}>
          <InputField
            label="Add Services"
            value={serviceText}
            // rightIcon={<BiPlus size={18} color="var(--primary-color)" />}
            placeholder="Photography"
            // onRightIconPress={(e) => {
            //   if (serviceText) {
            //     addServices();
            //   }
            // }}
            onChange={(e) => {
              setServiceText(e.target.value);
            }}
          />
          {/* {services?.length > 0 && (
            <Row gutter={[8, 16]} className={styles.servicesRow}>
              {services?.map((service, i) => (
                <Col xs={22} sm={10} md={22} lg={11} offset={1}>
                  <Row className={styles.serviceCol}>
                    <TextComponent textClass={styles.serviceText}>
                      {service}
                    </TextComponent>
                    <IoCloseSharp
                      color="var(--primary-color)"
                      size={20}
                      style={{ cursor: "pointer" }}
                      onClick={() => removeService(i)}
                    />
                  </Row>
                </Col>
              ))}
            </Row>
          )} */}
        </Col>
      </Row>
      <Col xs={24} md={12}>
        <TextareaField
          label="About"
          placeholder="Write about yourself"
          rows={6}
          value={about}
          onChange={(e) => setAbout(e.target.value)}
        />
      </Col>
      <TextComponent
        textClass={styles.documentsHeading}
        text={"Add Documents"}
      />
      <Row>
        {docs.map((doc, i) => {
          return (
            <>
              <RenderDocView docs={docs} doc={doc} i={i} setDocs={setDocs} />
            </>
          );
        })}
      </Row>
      <Row>
        <Col className={styles.imgCol} onClick={handleClick}>
          <img src={addDoc} className={styles.image} alt="docSelect" />
          <input
            type="file"
            accept=".pdf"
            multiple
            onChange={(el) =>
              el.target.files?.length &&
              setDocs([
                ...docs,
                ...Array.from(el.target.files).map((file, i) => ({
                  file: file,
                  uri: window.URL.createObjectURL(file),
                  fileName: file.name,
                  id: `${docs?.length + i + 12}`,
                })),
              ])
            }
            ref={docRef}
            className={styles.displayNone}
          />
        </Col>
        <Col className={styles.imgCol} >
          <img onClick={handleImageClick} src={addImage} className={styles.image} alt="imageSelect" />
          <input
            type="file"
            accept="image/*"
            multiple
            onChange={(e) => {
              e.preventDefault();
              setStaffImages([...staffImages, ...e.target.files]);
            }}
            ref={imageRef}
            style={{ display: "none" }}
          />
          {staffImages?.length > 0 &&
            <List
              className={styles.list}
              grid={{ gutter: 16 }}
              itemLayout="horizontal"
              dataSource={staffImages}
              renderItem={renderImages}
            />
          }
        </Col>
      </Row>
      <Row>
        <Col xs={24} md={10} lg={8}>
          <SubmitButton
            title={"Done"}
            btnClass={styles.solidBtn}
            onClick={onPressCreate}
          />
        </Col>
      </Row>
    </>
  );
};

export default AddSubVendor;
